import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { adminMaster } = stateEnum

const initialState = {  
  selectedAdmin: {},
}

const adminMasterSlice = createSlice({
  name: adminMaster,
  initialState,
  reducers: {
    resetAdminMaster: (state) => { 
      state.selectedAdmin = {}
    },
    setSelectedAdmin: (state, action) => {
      state.selectedAdmin = action.payload
    },
  }, 
})

export const { resetAdminMaster, setSelectedAdmin } = adminMasterSlice.actions
export default adminMasterSlice.reducer
